module.exports = __webpack_public_path__ + "static/baySeniorLendingbg-a26e22ae42cfa1b9eee540697fdbb944.jpg";